import { Button } from 'antd';
import { motion, useTime, useTransform } from 'framer-motion';
import styles from 'styles/components/animatedAIButton.module.scss';

const AnimatedAIButton = ({
  onClick,
  children,
  className,
  disabled = false,
  loading = false,
}) => {
  const time = useTime();
  const rotate = useTransform(time, [0, 2200], [0, 360], { clamp: false });

  const rotatingBG = useTransform(rotate, (value) => {
    return `conic-gradient(from ${
      value % 360
    }deg,rgb(224 132 103), rgb(255, 255, 255), rgb(182 85 210), rgb(255 117 105))`;
  });

  return (
    <div className={`${styles.aiSuggestionButtonWrapper} ${className}`}>
      <div className={styles.aiSuggestionButtonContainer}>
        <Button
          icon={<img
            src="/img/aicoach_grey.png"
            alt="AI coach"
            style={{ width: 20, height: 20 }}
          />}
          type="primary"
          onClick={onClick}
          className={`${styles.aiSuggestionButton}`}
          disabled={disabled}
          loading={loading}
          size="small"
        >
          {children}
        </Button>
        <motion.div
          className={styles.aiSuggestionButtonBackground}
          style={{ background: rotatingBG }}
        ></motion.div>
      </div>
    </div>
  );
};

export default AnimatedAIButton;
